<template>
    <div>
        <page-header title="Sponsors"></page-header>
        <div class="container">
            <content-loader v-if="$apollo.loading" title="sponsors"/>
            <div class="row mt-5 mb-4" v-else>
                <div class="col-md-6 col-lg-4 mb-5" v-for="sponsor in filteredSponsors" :key="sponsor.id">
                    <a :href="sponsor.website" target="_blank" :title="sponsor.name"  class="card-sponsor">
                        <div class="card">
                            <img :src="sponsor.picture" :alt='sponsor.name'>
                        </div>
                        <p class="card-title">{{ sponsor.name }}</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListSponsors from '@/gql/ListSponsors.gql';
import PageHeader from '@/components/global/PageHeader';

import ContentLoader from '@/components/global/ContentLoader';
import SearchBar from '@/components/global/SearchBar';

export default {
    name: 'Sponsor-list',
    components: {
        PageHeader,
        ContentLoader,
        SearchBar
    },
    data(){
        return {
            query:""
        }
    },

    computed:{

        filteredSponsors(){
          return this.sponsors && this.sponsors.filter((sponsor)=>{
            return sponsor.name.toLowerCase().includes(this.query.toLowerCase());
          })
        },

    },

    apollo: {
        sponsors: ListSponsors
    }
}
</script>

<style lang="scss" scoped>
    .card-sponsor {
        display: block;
        text-align: center;
        text-decoration: none;

        &:hover {
            .card {
                box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.06);
            }

            .card-title {
                color: $secondary;
            }
        }

        .card {
            padding: 25px;
            margin-bottom: 15px;
            height: 173px;
            display: flex;
            justify-content: center;
        }

        img {
            max-width: 100%;
            max-height: 100%;
            // max-width: 130px;
            margin: 0 auto;
        }

    }
</style>
